/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupPersonInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class GroupPersonApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'GroupPersons');
  }

  linkStudents(groupId: number, studentIds: number[]): Observable<GroupPersonInterface[]> {
    const path = `link-students/${groupId}`;
    const params = undefined;
    return this.post<GroupPersonInterface[]>(path, params, studentIds);
  }

  linkGroups(studentId: number, groupIds: number[]): Observable<GroupPersonInterface[]> {
    const path = `link-groups/${studentId}`;
    const params = undefined;
    return this.post<GroupPersonInterface[]>(path, params, groupIds);
  }
}
